<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one" :style="defaultHeight">
        <div class="page">
          <h3>顶尖、高效</h3>
        </div>
      </swiper-slide>
      <!-- <swiper-slide class="swiper-slide slide-two" :style="defaultHeight">
        <div class="page">
          <h3>Pos终端大图</h3>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-three" :style="defaultHeight">
        <div class="page">
          <h3>Saas服务系统</h3>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-four" :style="defaultHeight">
        <div class="page">
          <h3>企业荣誉与资质</h3>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-five" :style="defaultHeight">
        <div class="page">
          <h3>合作招商</h3>
        </div>
      </swiper-slide> -->
      <!-- 左箭头 -->
      <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
      <!-- 右箭头 -->
      <!-- <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
  </div>
</template>
 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "horizontal", //horizontal:水平方向移动,vertical:垂直方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: false, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        }
      },
      // <el-main>高度
      defaultHeight: {
        minHeight : ""
      }
    };
  },
  created() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.$http
      .all([
        this.$http.get("Cases/GetCasesAll"),
        this.$http.get(`News?type=1&num=3`)
      ])
      .then(
        this.$http.spread((responseCases, responseNews) => {
          this.caseList = responseCases.data;
          this.newsList = responseNews.data;
          this.loading = false;
        })
      );
  },
  methods: {
    // 定义el-main高度
    getHeight() {
      this.defaultHeight.minHeight  = window.innerHeight - 60 + "px";
    }
  }
};
</script>
 
<style lang="scss" scoped>
.swiper-slide {
  font-size: 24px;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: flex-start;
  justify-content: flex-end;

  .page {
    padding: 70px 240px 0 0;
    h3 {
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      font-weight: bold;
      font-size: 96px;
      color: #FFFFFF;
      line-height: 122px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}

.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}
.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-three {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-four {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-five {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-six {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}

/* 自定义箭头样式 */
.swiper-button-prev, .swiper-button-next {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  padding: 10px;
  margin: 0 20px 0 20px;
  opacity: 0.8;
  cursor: pointer;
  border-radius: 20%; /* 可选，设置圆角 */
}
.swiper-button-prev {
		background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23FFFFFF'%2F%3E%3C%2Fsvg%3E");
	}
 
.swiper-button-next {
  /* 改变颜色部分：007aff → FDBD1F */
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23FFFFFF'%2F%3E%3C%2Fsvg%3E");
}
/* 鼠标悬停时改变背景颜色 */
.swiper-button-prev:hover, .swiper-button-next:hover {
  background-color: rgb(29, 29, 29, 0.3);
}

.order {
  order: -1;
}
.order-img {
  order: 1;
}
</style>